import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IFilterComplete } from "src/app/filter-complete/filter-complete";

export interface ObservationDialogEditRequest {
  text: string;
  textMenu: string;
  noRequired: boolean;
  filterText: string;
  filterItems: IFilterComplete[];
}

export interface ObservationDialogEditResponse {
  text: string;
  selectedFilter?: IFilterComplete;
}

@Component({
  selector: "app-observation-dialog",
  templateUrl: "./observation-dialog.component.html",
  styleUrls: ["./observation-dialog.component.css"],
})
export class ObservationDialogComponent implements OnInit {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ObservationDialogComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public observationDialogEditRequest: ObservationDialogEditRequest
  ) {
    this.form = this.formBuilder.group({
      filterItem: [
        null,
        observationDialogEditRequest.filterItems ? Validators.required : null,
      ],
      observation: [
        observationDialogEditRequest.text, null
      ],
    });
  }

  get f() {
    return this.form.controls;
  }

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    if (this.form.valid) {
      this.dialogRef.close({
        text: this.form.controls.observation.value,
        selectedFilter: this.form.controls.filterItem.value,
      });
    }
  }
}
